// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0c1txw{display:flex}
._4cvr1h6o{align-items:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/editor-common/dist/esm/ui/Toolbar/ExpandIcon.compiled.css"],"names":[],"mappings":"AAAA,WAAW,YAAY;AACvB,WAAW,kBAAkB","sourcesContent":["._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
